import React, { useState, useEffect } from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { projects as getProjects } from '../../common/api/projects'
import Header from "./Header";
import Impact from './Impact';
import DrivingCalculator from "./DrivingCalculator";
import ExtraTips from './ExtraTips';
import Tip from "./Tip";
import EnterpriseJourney from './EnterpriseJourney';
import Projects from "./Projects";
import FAQs from "./FAQs";
import Footer from "./Footer";

const LandingPage = ({ merchantCode, fetchedImpact }) => {
    const [projects, setProjects] = useState();

    useEffect(() => {
        getProjects(null, merchantCode, null)
            .then(response => response.json())
            .then(data => setProjects(data))
            .catch(setProjects);

    }, []);

    return (
        <div>
            <Header/>
            <Impact fetchedImpact={fetchedImpact}/>
            <DrivingCalculator merchantCode={'BES_NZ_AA_NEW_ZEALAND'}/>
            <Tip/>
            
            <EnterpriseJourney/>
            <ExtraTips merchantCode={merchantCode}/>
            {/*<Testimonials/>*/}
            <FAQs/>
            <Projects projects={projects} />


            {/*<div className="bg-green-light py-6">
                <div className="container text-center">
                    <div className="mb-5 center mw-600px">
                        <h2 className="font-light">Make a difference in fighting climate change</h2>
                        <p>Purchase a subscription to make an ongoing, traceable difference. We&apos;ll show you how your positive impacts grow each month.</p>
                    </div>

                    country && <PlansList
                        selectedPlan={selectedPlan}
                        onSelectedPlanChange={setSelectedPlan}
                        planChosen={planChosen}
                        country={country}
                        setLocationModalVisible={setShowModal}
                    />}
                </div>
            </div>*/}


            <Footer/>
        </div>
    )
}


export default LandingPage;